import camelCase from 'lodash.camelcase';

type CamelCaseObjectDeepType = <T = object>(object?: unknown) => T;

export const convertToCamelCase: CamelCaseObjectDeepType = <T = object>(object?: unknown) => {
  if (Array.isArray(object)) {
    return object.map(convertToCamelCase) as unknown as T;
  }

  if (typeof object === 'object' && object !== null && object.constructor === Object) {
    return Object.fromEntries(
      Object.entries(object).map(([key, value]) => [camelCase(key), convertToCamelCase(value)]),
    ) as unknown as T;
  }

  return object as T;
};
